function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

export function getBackendUrl() {
  // Forçar api.appone.com.br quando em app.appone.com.br (evita WebSocket no domínio errado)
  if (typeof window !== "undefined" && window.location?.hostname === "app.appone.com.br") {
    return "https://api.appone.com.br";
  }
  const url = getConfig("VITE_BACKEND_URL");
  if (url) return url;
  if (typeof window !== "undefined" && window.location?.hostname?.includes("appone")) {
    return "https://api.appone.com.br";
  }
  return null;
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}
